import { render, staticRenderFns } from "./ItemFilterList.vue?vue&type=template&id=6f65c46d"
import script from "./ItemFilterList.vue?vue&type=script&lang=js"
export * from "./ItemFilterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports